const routes = {
  LOGIN: '/',
  CONTENTS: '/contents',
  ADD_CONTENTS: '/add_contents',
  SEND_NOTIFICATION: '/send_notification',
  PRICE: '/price',
  FORGET_PASSWORD: '/forget-password',
  CONTENT: '/content/:id'
};

export default routes;
